import { Card } from "@mantine/core";
import DynamicFormBuilder from "../FormBuilder/DynamicFormBuilder.component";
import { useSingleForm } from "../../../../api/services/useServices";

export default function AgentSignupForm() {
  const { data: singleForm, isSuccess: isFormLoaded } = useSingleForm({
    params: {
      module_type: "agent",
    },
  });

  return (
    <Card radius="md">
      {isFormLoaded && (
        <DynamicFormBuilder
          singleForm={singleForm}
          onSubmit={{
            successPage: "/agent-signup/success",
            callback: () => {
              // localStorage.setItem("isAgent", "true-signup");
            },
          }}
          isPublicForm
        />
      )}
    </Card>
  );
}
